import React, { useMemo, useEffect, useState } from "react";
import { OPTIONS, STATUS_OPTIONS } from "./config";
import PanelDropDown from "components/Common/Dropdowns/PanelDropDown";
import DatePicker from "components/Common/DatePicker/datepicker";

const today = new Date();
const yyyy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = `0${dd}`;
if (mm < 10) mm = `0${mm}`;

const formattedToday = `${yyyy}-${mm}-${dd}`;

today.setDate(today.getDate() - 1);
let yesterdayDd = today.getDate();
let yesterdayMm = today.getMonth() + 1;
const yesterdayYyyy = today.getFullYear();

if (yesterdayDd < 10) yesterdayDd = `0${yesterdayDd}`;
if (yesterdayMm < 10) yesterdayMm = `0${yesterdayMm}`;

const formattedYesterday = `${yesterdayYyyy}-${yesterdayMm}-${yesterdayDd}`;

const OPTIONAL_KEYS = [
  "franchise_id",
  "appointment_id",
  "barcode_id",
  "registration_no",
  "patient_bill_no",
  "patient_name",
];

const FilterCancellation = (props) => {
  const { filters, updateFilter, updateMultipleFilters } = props;

  const [localFilters, setLocalFilters] = useState({
    ...filters,
    from_date: filters.from_date || formattedToday,
    to_date: filters.to_date || formattedToday,
  });

  useEffect(() => {
    setLocalFilters((prev) => ({
      ...prev,
      ...filters,
      from_date: filters.from_date || formattedToday,
      to_date: filters.to_date || formattedToday,
    }));
  }, []);

  const setLocal = (key, value) => {
    setLocalFilters((prev) => ({ ...prev, [key]: value }));
  };

  const setLocalMultiple = (obj) => {
    setLocalFilters((prev) => ({ ...prev, ...obj }));
  };

  const handleSearch = () => {
    const cleanedFilters = Object.fromEntries(
      Object.entries(localFilters)
        .filter(([key, v]) => {
          if (OPTIONAL_KEYS.includes(key)) return true;
          return v !== "" && v !== undefined && v !== null;
        })
        .map(([key, v]) => {
          if (OPTIONAL_KEYS.includes(key) && (v === "" || v === null)) {
            return [key, undefined];
          }
          return [key, v];
        }),
    );
    updateMultipleFilters(cleanedFilters);
  };

  const onDropdownChange = (value) => {
    setLocalMultiple({
      keyword: value,
      appointment_id: undefined,
      barcode_id: undefined,
      registration_no: undefined,
      patient_bill_no: undefined,
    });
  };

  const filterVal = useMemo(() => {
    return (
      OPTIONS.find((option) => option.key === localFilters.keyword)?.value ||
      "Patient Name"
    );
  }, [localFilters]);

  const statusVal = useMemo(() => {
    return STATUS_OPTIONS.find(
      (option) => option.key === localFilters.is_active,
    )?.value;
  }, [localFilters]);

  const getInputType = () => {
    if (localFilters.keyword === "patient_bill_no") return "number";
    return "text";
  };

  const getPlaceholder = () => filterVal;

  const getCurrentValue = () => {
    const field = localFilters.keyword || "patient_name";
    return localFilters[field] || "";
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <div>
        <button
          className="dropdown-toggle btn btn-o box-shadow-none active"
          role="button"
          data-bs-toggle="dropdown"
        >
          {statusVal}
        </button>
        <ul className="dropdown-menu">
          {STATUS_OPTIONS.map(({ key, value }) => (
            <li
              className="dropdown-item"
              onClick={() => setLocal("is_active", key)}
              key={key}
            >
              {value}
            </li>
          ))}
        </ul>
      </div>

      <div>
        <button
          className="dropdown-toggle btn btn-o box-shadow-none active"
          role="button"
          data-bs-toggle="dropdown"
        >
          {filterVal}
        </button>
        <ul className="dropdown-menu">
          {OPTIONS.map(({ key, value }) => (
            <li
              className="dropdown-item"
              onClick={() => onDropdownChange(key)}
              key={key}
            >
              {value}
            </li>
          ))}
        </ul>
      </div>

      <div>
        <input
          type={getInputType()}
          placeholder={`Search by ${getPlaceholder()}`}
          className="form-control"
          value={getCurrentValue()}
          onChange={(e) => {
            const field = localFilters.keyword || "patient_name";
            setLocal(field, e.target.value);
          }}
        />
      </div>

      <div>
        <input
          type="text"
          placeholder="Search by Patient Name"
          className="form-control"
          value={localFilters.patient_name || ""}
          onChange={(e) => setLocal("patient_name", e.target.value)}
        />
      </div>

      <div style={{ width: "250px" }}>
        <PanelDropDown
          setFilterValue={(key, val) => setLocal(key, val)}
          className="w-100"
          selectedValue={localFilters?.franchise_id}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <label style={{ width: "120px" }}>Date From:</label>
        <DatePicker
          name="from_date"
          value={localFilters.from_date || formattedYesterday}
          onChange={(date) => setLocal("from_date", date)}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <label style={{ width: "80px" }}>Date To:</label>
        <DatePicker
          name="to_date"
          value={localFilters.to_date || formattedToday}
          onChange={(date) => setLocal("to_date", date)}
        />
      </div>

      <div>
        <button className="btn btn-primary" onClick={handleSearch}>
          Search
        </button>
      </div>
    </div>
  );
};

export default FilterCancellation;
